module.exports = {
	"notification.message": "Wix.com usa cookies para brindarte la mejor experiencia posible.",
	"notification.got.it": "¡Entendido!",
	"notification.more.info": "Leer más"
};


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_es.json
// module id = 40
// module chunks = 0